'use strict';

/**
 * Display the returned message.
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} button - button that was clicked for contact us sign-up
 */
function displayMessage(data, button) {
    $.spinner().stop();
    var status;
    if (data.success) {
        status = 'alert-success';
    } else {
        status = 'alert-danger';
    }

    if ($('.contact-us-signup-message').length === 0) {
        $('body').append(
            '<div class="contact-us-signup-message"></div>'
        );
    }
    $('.contact-us-signup-message')
        .append('<div class="contact-us-signup-alert alert ' + status + '" role="alert">' + data.msg + '</div>');

    setTimeout(function () {
        $('.contact-us-signup-message').remove();
        button.removeAttr('disabled');
    }, 3000);
}

/**
 * Handle Contact us form submission
 * @param {Object} form - jquery object of form
 */
function submitContactUsAction(form) {
    var button = $('.subscribe-contact-us');
    var url = form.attr('action');
    $.spinner().start();
    button.attr('disabled', true);
    $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: form.serialize(),
        success: function (data) {
            displayMessage(data, button);
            if (data.success) {
                $('.contact-us').trigger('reset');
            }
        },
        error: function (err) {
            displayMessage(err, button);
        }
    });
}

/**
 * Hides the select element based on counrty select
 * @param {jqueryObject} $selectElement - the select form element
 */
function hideStateProvince($selectElement) {
    $selectElement.addClass('d-none');
    $selectElement.find('select').removeAttr('required').removeClass('required');
    $selectElement.removeClass('required');
}

/**
 * Shows the select element based on counrty select
 * @param {jqueryObject} $selectElement - the select form element
 */
function showStateProvience($selectElement) {
    $selectElement.removeClass('d-none');
    $selectElement.find('select').prop('required', true).addClass('required');
    $selectElement.addClass('required');
}

module.exports = {

    submit: function () {
        $('form[name$="_newslettersignup"]').on('submit', function (e) {
            e.preventDefault();
            var form = this;
            var $recaptcha = $(form).find('[name="g-recaptcha-response"]');
            if ($recaptcha.length) {
                var siteKey = $recaptcha.data('sitekey');
                var action = $(form).find('[name="g-recaptcha-action"]').val();
                grecaptcha.execute(siteKey, { action: action }).then(function (token) {
                    $recaptcha.val(token);
                    form.submit();
                });
            } else {
                form.submit();
            }
        });
    },

    subscribeContact: function () {
        $('form.contact-us').submit(function (e) {
            e.preventDefault();
            var $form = $(this);
            var $recaptcha = $form.find('[name="g-recaptcha-response"]');
            if ($recaptcha.length) {
                var siteKey = $recaptcha.data('sitekey');
                var action = $form.find().find('[name="g-recaptcha-action"]').val();
                grecaptcha.execute(siteKey, { action: action }).then(function (token) {
                    $recaptcha.val(token);
                    submitContactUsAction($form);
                });
            } else {
                submitContactUsAction($form);
            }
        });
    },
    // show/hides states field
    showHideStates: function () {
        var $stateFormGroup = $('.contact-us-landing-page .state-form-group');
        var $provinceFormGroup = $('.contact-us-landing-page .province-form-group');
        $('#country-selector').on('change', function () {
            if (this.value === 'United States' && $stateFormGroup.hasClass('d-none')) {
                showStateProvience($stateFormGroup);
                if (!$provinceFormGroup.hasClass('d-none')) {
                    hideStateProvince($provinceFormGroup);
                }
            } else if (this.value === 'Canada' && $provinceFormGroup.hasClass('d-none')) {
                showStateProvience($provinceFormGroup);
                if (!$stateFormGroup.hasClass('d-none')) {
                    hideStateProvince($stateFormGroup);
                }
            } else if (!$stateFormGroup.hasClass('d-none')) {
                hideStateProvince($stateFormGroup);
            } else if (!$provinceFormGroup.hasClass('d-none')) {
                hideStateProvince($provinceFormGroup);
            }
        });
    }
};

$(document).ready(function () {
    var contact = sessionStorage.getItem('customContact');
    if (contact === 'true') {
        $('#contact-topic option[value="CustomShop"]').remove();
        $('#contact-topic option[Value="Orders"]').eq(0).before($('<option>', { value: 'CustomShop', text: 'Custom Shop' }));
        $('#contact-topic option[value="CustomShop"]').attr('selected', 'selected');
    }
    sessionStorage.clear();

    if ($('.order-inquiry-only').length > 0) {
        $('#contact-topic').on('change', function () {
            var currTopic = $('#contact-topic').val();
            if (currTopic === 'Orders' || currTopic === 'OrderCancellation') {
                $('.order-inquiry-only').show();
                $('.order-inquiry-only .required input').prop('required', true);
            } else {
                $('.order-inquiry-only').hide();
                $('.order-inquiry-only .required input').prop('required', false);
            }
        });
    }
});
